// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".el-row[data-v-75184b8e] {\n  margin-bottom: 10px;\n}\n.el-row[data-v-75184b8e]:last-child {\n  margin-bottom: 0;\n}", "",{"version":3,"sources":["/home/auto/b2b/releases/59/src/views/Tuning/List.vue"],"names":[],"mappings":"AACA;EACE,mBAAA;AAAF;AAEE;EACE,gBAAA;AAAJ","file":"List.vue","sourcesContent":["\n.el-row {\n  margin-bottom: 10px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
